module.exports = __webpack_public_path__ + "svg_80x80/aws.4baa50.svg";